import { useCallback } from 'react';
import { getContainer } from '@framework/di/getContainer';
import ResearchRepository from '@/creditflowresearch/infrastructure/repository/ResearchRepository';
import { IResearchFilterState, IResearchFilterItems } from '@/creditflowresearch/domain/vo/research/IFilterContextData';

export const useFilterApi = (
  setIsFetching: (value: boolean) => void,
  setItems: (items: IResearchFilterItems) => void,
) => {
  const container = getContainer();
  const researchRepository = container.get(ResearchRepository);

  const getResearchFilter = useCallback(async (filtersPayload: IResearchFilterState): Promise<IResearchFilterItems> => {
    setIsFetching(true);
    try {
      const response = await researchRepository.getResearchFilter({ filter: filtersPayload });
      setItems(response);
      return response;
    } finally {
      setIsFetching(false);
    }
  }, [researchRepository, setIsFetching, setItems]);

  const getResearchFilterByHash = useCallback(async (hash: string | string[]) => {
    // @ts-ignore TODO: incorrect type of payload with correct repository type
    return researchRepository.getResearchFilterByHash(hash);
  }, [researchRepository]);

  return {
    getResearchFilter,
    getResearchFilterByHash,
  };
};
